/* eslint-disable linebreak-style */
import es from 'vuetify/es5/locale/es';

export default {
  label: 'Español',
  login: {
    login: 'Iniciar Sesión',
    username: 'Nombre de usuario',
    password: 'Contraseña',
  },
  menu: {
    home: 'Inicio',
    map: 'Mapa',
    reports: 'Reportes',
    users: 'Usuarios',
    cameras: 'Camaras',
    bus: 'Transporte Urbano',
    devices: 'Unidades',
    calendars: 'Calendarios',
    drivers: 'Conductores',
    groups: 'Grupos',
    maintenance: 'Mantenimiento',
    geofences: 'Geocercas',
    incidents: 'Incidentes',
    lpr: 'Listado',
    'analytics-monitor': 'Monitor de Analíticos',
    'analytics-history': 'Histórico de Analíticos',
    'analytics-faces': 'Búsqueda de rostros (Powered by Nexus)',
    'analytics-intelli': 'Búsqueda Inteligente',
    'lpr-categories': 'Categorías',
    sensor: 'Listado',
    fuelPrice: 'Precio del combustible',
    deviceCategories: 'Categorías',
    'video-servers': 'Servidores de video',
    administracion: 'Administración',
    video: 'Video',
    analiticos: 'Analíticos',
    botones: 'Botones de pánico',
    dispositivos: 'Dispositivos',
    'incident-categories': 'Tipos de incidente',
    'sensor-categories': 'Tipos',
    routes: 'Rutas',
    profiles: 'Perfiles',
    'mando-unico': 'Mando Único',
    'mando-unico-geofences': 'Geocercas',
    'mando-unico-region': 'Región',
    'mando-unico-sector': 'Sector',
    'mando-unico-cuadrante': 'Cuadrante',
    'kalan-sos': 'Alertamiento Colibrí',
    'listas-negras': 'Listas negras',
    'lista-negra': 'Entradas',
    'lista-negra-categorias': 'Categorías',
    'lista-negra-webhooks': 'Webhooks',
  },
  profiles: {
    name: 'Perfil',
    plural_name: 'Perfiles',
    create: 'Nuevo perfil',
    update: 'Actualizar perfil',
    read: 'Ver perfil',
    delete: 'Eliminar perfil',
    delete_confirm: '¿Estás seguro de eliminar el perfil?'
  },
  'video-servers': {
    name: 'Servidor de video',
    plural_name: 'Servidores de video',
    create: 'Nuevo servidor de video',
    update: 'Actualizar servidor de video',
    read: 'Ver servidor de video',
    delete: 'Eliminar servidor de video',
    delete_confirm: '¿Estás seguro de eliminar el servidor de video?'
  },
  'incident-categories': {
    name: 'Tipo de incidente',
    plural_name: 'Tipos de incidente',
    create: 'Nuevo tipo de incidente',
    update: 'Actualizar tipo de incidente',
    read: 'Ver tipo de incidente',
    delete: 'Eliminar tipo de incidente',
    delete_confirm: 'Estás seguro de eliminar el tipo de incidente?'
  },
  'sensor-categories': {
    name: 'Tipo de boton de pánico',
    plural_name: 'Tipos de boton de pánico',
    create: 'Nuevo tipo de boton de pánico',
    update: 'Actualizar tipo de boton de pánico',
    read: 'Ver tipo de boton de pánico',
    delete: 'Eliminar tipo de boton de pánico',
    delete_confirm: 'Estás seguro de eliminar el tipo de boton de pánico?'
  },
  routes: {
    name: 'Ruta',
    plural_name: 'Rutas',
    create: 'Nueva ruta',
    update: 'Actualizar ruta',
    read: 'Ver ruta',
    delete: 'Eliminar ruta',
    delete_confirm: 'Estás seguro de eliminar la ruta?'
  },
  users: {
    name: 'Usuario',
    plural_name: 'Usuarios',
    create: 'Nuevo usuario',
    update: 'Actualizar usuario',
    read: 'Ver usuario',
    delete: 'Eliminar usuario',
    delete_confirm: 'Estás seguro de eliminar el usuario?',
    permissions: 'Permisos'
  },
  bus: {
    name: 'Transporte Urbano',
    plural_name: 'Transportes Urbanos',
    create: 'Nuevo Transporte Urbano',
    update: 'Actualizar Transporte Urbano',
    read: 'Ver Transporte Urbano',
    delete: 'Eliminar Transporte Urbano',
    delete_confirm: 'Estás seguro de eliminar el Transporte Urbano?'
  },
  devices: {
    name: 'Unidad',
    plural_name: 'Unidades',
    create: 'Nuevo unidad',
    update: 'Actualizar unidad',
    read: 'Ver unidad',
    delete: 'Eliminar unidad',
    delete_confirm: 'Estás seguro de eliminar el unidad?'
  },
  'device-categories': {
    name: 'Categoria de dispositivo',
    plural_name: 'Categorias de dispositivos',
    create: 'Nuevo categoria de dispositivo',
    update: 'Actualizar categoria de dispositivo',
    read: 'Ver categoria de dispositivo',
    delete: 'Eliminar categoria de dispositivo',
    delete_confirm: 'Estás seguro de eliminar la categoria de dispositivo?'
  },
  calendars: {
    name: 'Calendario',
    plural_name: 'Calendarios',
    create: 'Nuevo calendario',
    update: 'Actualizar calendario',
    read: 'Ver calendario',
    delete: 'Eliminar calendario',
    delete_confirm: 'Estás seguro de eliminar el calendario?'
  },
  drivers: {
    name: 'Conductor',
    plural_name: 'Conductores',
    create: 'Nuevo conductor',
    update: 'Actualizar conductor',
    read: 'Ver conductor',
    delete: 'Eliminar conductor',
    delete_confirm: 'Estás seguro de eliminar el conductor?'
  },
  groups: {
    name: 'Grupo',
    plural_name: 'Grupos',
    create: 'Nuevo grupo',
    update: 'Actualizar grupo',
    read: 'Ver grupo',
    delete: 'Eliminar grupo',
    delete_confirm: 'Estás seguro de eliminar el grupo?'
  },
  cameras: {
    name: 'Camara',
    plural_name: 'Camaras',
    create: 'Nueva camara',
    update: 'Actualizar camara',
    read: 'Ver camara',
    delete: 'Eliminar camara',
    delete_confirm: 'Estás seguro de eliminar la camara?'
  },
  geofences: {
    name: 'Geocerca',
    plural_name: 'Geocercas',
    create: 'Nueva geocerca',
    update: 'Actualizar geocerca',
    read: 'Ver geocerca',
    delete: 'Eliminar geocerca',
    delete_confirm: 'Estás seguro de eliminar la geocerca?'
  },
  'mando-unico': {
    name: 'Mando Único',
    plural_name: 'Mandos Únicos',
    create: 'Nuevo mando unico',
    update: 'Actualizar mando unico',
    read: 'Ver mando unico',
    delete: 'Eliminar mando unico',
    delete_confirm: 'Estás seguro de eliminar el mando unico?'
  },
  'mando-unico-region': {
    name: 'Region de Mando Único',
    plural_name: 'Regiones de Mandos Únicos',
    create: 'Nueva region mando unico',
    update: 'Actualizar región',
    read: 'Ver región',
    delete: 'Eliminar región',
    delete_confirm: 'Estás seguro de eliminar el región?'
  },
  'mando-unico-sector': {
    name: 'Sector de Mando Único',
    plural_name: 'Sectores de Mandos Únicos',
    create: 'Nuevo sector mando unico',
    update: 'Actualizar sector',
    read: 'Ver sector',
    delete: 'Eliminar sector',
    delete_confirm: 'Estás seguro de eliminar el sector?'
  },
  'mando-unico-cuadrante': {
    name: 'Cuarante de Mando Único',
    plural_name: 'Cuarantes de Mandos Únicos',
    create: 'Nuevo cuadrante mando unico',
    update: 'Actualizar cuadrante',
    read: 'Ver cuadrante',
    delete: 'Eliminar cuadrante',
    delete_confirm: 'Estás seguro de eliminar el cuadrante?'
  },
  incidents: {
    name: 'Incidente',
    plural_name: 'Incidentes',
    create: 'Nuevo incidente',
    update: 'Actualizar incidente',
    read: 'Ver incidente',
    delete: 'Eliminar incidente',
    delete_confirm: 'Estás seguro de eliminar el incidente?'
  },
  'analytic-categories': {
    name: 'Categoria de analitico',
    plural_name: 'Categorias de analiticos',
    create: 'Nueva categoria de analitico',
    update: 'Actualizar categoria de analitico',
    read: 'Ver categoria de analitico',
    delete: 'Eliminar categoria de analitico',
    delete_confirm: 'Estás seguro de eliminar la categoria de analitico?'
  },
  'analytic-devices': {
    name: 'Dispositivo de analitico',
    plural_name: 'Dispositivos de analiticos',
    create: 'Nuevo dispositivo de analitico',
    update: 'Actualizar dispositivo de analitico',
    read: 'Ver dispositivo de analitico',
    delete: 'Eliminar dispositivo de analitico',
    delete_confirm: 'Estás seguro de eliminar el dispositivo de analitico?'
  },
  lpr: {
    name: 'Analitico',
    plural_name: 'Analiticos',
    create: 'Nuevo Analitico',
    update: 'Actualizar Analitico',
    read: 'Ver Analitico',
    delete: 'Eliminar Analitico',
    delete_confirm: 'Estás seguro de eliminar el Analitico?'
  },
  sensor: {
    name: 'Botón de pánico',
    plural_name: 'Botones de pánico',
    create: 'Nuevo botón de pánico',
    update: 'Actualizar botón de pánico',
    read: 'Ver botón de pánico',
    delete: 'Eliminar botón de pánico',
    delete_confirm: 'Estás seguro de eliminar el botón de pánico?'
  },
  maintenance: {
    name: 'Mantenimiento',
    plural_name: 'Mantenimientos',
    create: 'Nuevo mantenimiento',
    update: 'Actualizar mantenimiento',
    read: 'Ver mantenimiento',
    delete: 'Eliminar mantenimiento',
    delete_confirm: 'Estás seguro de eliminar el mantenimiento?'
  },
  fuelPrice: {
    name: 'Precio del combustible',
    plural_name: 'Precios del combustible',
    create: 'Nuevo precio del combustible',
    update: 'Actualizar precio del combustible',
    read: 'Ver precio del combustible',
    delete: 'Eliminar precio del combustible',
    delete_confirm: 'Estás seguro de eliminar el precio del combustible?'
  },
  rule: {
    required: 'Campo requerido',
  },
  face_search: {
    title: 'Búsqueda de Rostros',
    subtitle_count: '{n} resultados',
    filters: {
      photo: 'Arrastra o haz clic para subir una foto',
      photo_invalid_type: 'Formato no soportado. Usa JPG, PNG o WebP.',
      photo_too_large: 'La imagen excede 10 MB.',
      mode: 'Modo de zona',
      mode_all: 'Todas las cámaras',
      mode_city: 'Por ciudad',
      mode_radius: 'Por radio',
      city: 'Ciudad',
      city_empty: 'No hay ciudades disponibles',
      define_radius: 'Definir centro en mapa',
      define_radius_active: 'Haz clic en el mapa para fijar el centro',
      cancel_radius: 'Cancelar',
      radius_meters: 'Radio: {n} m',
      from: 'Desde',
      to: 'Hasta',
      min_similarity: 'Similitud mínima',
      search: 'Buscar',
      clear: 'Limpiar',
      no_photo_yet: 'Selecciona una foto antes de buscar.',
    },
    results: {
      idle: 'Carga una foto y presiona Buscar',
      empty: 'No se encontraron coincidencias',
      loading: 'Buscando rostros...',
      load_more: 'Cargar más',
      showing: 'Mostrando {n} de {total}',
      camera_unavailable: 'Cámara fuera del área visible',
    },
    enrich: {
      title: 'Datos del rostro buscado',
      no_identifier: 'Murphy no disponible para tu usuario',
      loading: 'Consultando Murphy...',
      failed: 'Enriquecimiento Murphy no disponible',
      retry: 'Reintentar',
      fecha_nac_label: 'Fecha de nacimiento',
      curp_label: 'CURP',
      candidates_count: 'Otros candidatos ({n})',
      no_match: 'El sistema no reconoció a esta persona.',
      no_records: 'Sin información detallada disponible para esta persona.',
      persona_of: 'Persona {i} de {n}',
    },
    errors: {
      session_expired: 'Sesión expirada — vuelve a iniciar sesión',
      file_too_large: 'La imagen excede 10 MB',
      unavailable: 'Servicio de búsqueda no disponible',
      no_face: 'No se detectó un rostro en la imagen',
      network: 'Error de red',
      retry: 'Reintentar',
    },
  },
  'blacklist-entry': {
    name: 'Placa en lista negra',
    plural_name: 'Lista negra',
    create: 'Agregar placa',
    update: 'Editar placa',
    read: 'Ver placa',
    delete: 'Quitar de la lista',
    delete_confirm: '¿Quitar esta placa de la lista negra?',
  },
  'blacklist-category': {
    name: 'Categoría de lista negra',
    plural_name: 'Categorías de lista negra',
    create: 'Nueva categoría',
    update: 'Editar categoría',
    read: 'Ver categoría',
    delete: 'Eliminar categoría',
    delete_confirm: '¿Eliminar esta categoría?',
  },
  'blacklist-webhook': {
    name: 'Webhook de lista negra',
    plural_name: 'Webhooks de lista negra',
    create: 'Nuevo webhook',
    update: 'Editar webhook',
    read: 'Ver webhook',
    delete: 'Eliminar webhook',
    delete_confirm: '¿Eliminar este webhook?',
  },
  ...es,
};
